// "Rental and business detail" (ticket 072, W2/W3 + feedback): one inner box per rental or
// self-employment card of a saved intake. Numbers are as entered (one unit line per box, right
// aligned); the Total row carries the as-entered currency and period and the next line converts
// it to euros per year (the figure the IRPF table shows). Foreign tax paid is a memo line.
import React from 'react'
import { SourceCardHeader } from './BriefParts'

function DetailBlock({ b }) {
  return (
    <div className="brief-detail-box">
      <div className="brief-fact-group-title">{b.title}</div>
      <div className="u-desc-xs">Amounts in {b.unit}</div>
      <div className="brief-findings-wrap">
        <table className="brief-findings-table brief-detail-table">
          <tbody>
            {b.rows.map((r) => (
              <tr key={r.label} className="brief-findings-tr">
                <td className="brief-findings-td">
                  {r.label}
                  {r.source && <div className="u-desc-xs">{r.source}</div>}
                </td>
                <td className="brief-findings-td brief-detail-num">{r.value}</td>
              </tr>
            ))}
            {b.total && (
              <tr className="brief-findings-tr brief-findings-total-row">
                <td className="brief-findings-td"><strong>{b.total.label}</strong></td>
                <td className="brief-findings-td brief-detail-num"><strong>{b.total.value}</strong></td>
              </tr>
            )}
            {b.euro && (
              <tr className="brief-findings-tr">
                <td className="brief-findings-td">
                  {b.euro.label}
                  {b.fx && <div className="u-desc-xs">Exchange rate: {b.fx}</div>}
                </td>
                <td className="brief-findings-td brief-detail-num">{b.euro.value}</td>
              </tr>
            )}
            {b.memo.map((r) => (
              <tr key={r.label} className="brief-findings-tr">
                <td className="brief-findings-td">
                  {r.label}
                </td>
                <td className="brief-findings-td brief-detail-num">{r.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export function RentalBusinessDetailCard({ blocks }) {
  if (!blocks || blocks.length === 0) return null
  return (
    <div className="brief-source-card completed">
      <SourceCardHeader title="Rental and business detail" />
      <div className="brief-source-card-body">
        {blocks.map((b) => <DetailBlock key={b.id} b={b} />)}
      </div>
    </div>
  )
}
